import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './ReceiptDetails.module.scss';

function ResendCounter({ onResend, countDownTime, loading }) {
  const [counter, setCounter] = useState(countDownTime);

  useEffect(() => {
    const timer = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  useEffect(() => {
    if (loading === false) {
      setCounter(countDownTime);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  const onResendHandler = () => {
    setCounter(countDownTime);
    onResend();
  };

  return (
    <>
      {!loading && counter === 0 && (
        <div className={styles.counter}>
          Didn't get the code?&nbsp;
          <span className="link" onClick={onResendHandler}>
            RESEND
          </span>
        </div>
      )}
      {!loading && counter > 0 && <div className={styles.counter}>{counter}</div>}
      {loading && <div>loading</div>}
    </>
  );
}

ResendCounter.propTypes = {
  onResend: PropTypes.func,
  countDownTime: PropTypes.number,
  loading: PropTypes.bool,
};

ResendCounter.defaultProps = {
  onResend: () => {},
  countDownTime: 90,
  loading: false,
};

export default ResendCounter;
